import React from "react";
import { useTranslation } from "react-i18next";
import UploadRegulationData from "./UploadRegulationData";
import NavbarIconsGenericComponent from "../generic-nav-bar/NavbarIconsGenericComponent";
import { debugLogPages } from "../../app/helpers/debugHelper";

const ImportDataRegulationScreen = () => {
  debugLogPages(':: ImportDataRegulationScreen'); 

  const { t } = useTranslation();

  return (
    <>
      <NavbarIconsGenericComponent componentName="ImportDataRegulation" />
      <div className="d-flex justify-content-center page-title">{t("admin.importdata.regulation.title")}</div>
      <hr className="line-hr" />

        <div>
        <UploadRegulationData />
        </div>
      
    </>
  );
};

export default ImportDataRegulationScreen;
